import {Box, Flex, Text} from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';
import Emoji from './Emoji';

const WorldParticipants = ({ownerId, participants, userIdsBlockedByUser}) => (
  <Text
    align="left"
    display="flex"
    flexWrap="wrap"
    fontSize="sm"
    p={1}
  >
    {_.toPairs(participants)// {id: alias, ...} => [[id, alias], ...]
      .sort(([idA, aliasA], [idB, aliasB]) =>
        idA === ownerId
          ? -1
          : aliasA > aliasB
            ? 1
            : 0)
      .map(([id, alias], idx, coll) => {
        const isBlockedByUser = userIdsBlockedByUser[id];
        const displayAlias = alias.length > 16 ? `${alias.substring(0, 8)}...` : alias;

        return (
          <Text
            as="span"
            color={isBlockedByUser ? '#FFB3AE' : 'lightgrey'}
            key={id}
            marginRight={1}
          >
            <Emoji>{ownerId === id && '👑'}</Emoji>
            <Emoji>{isBlockedByUser && '🚫'}</Emoji>
            {displayAlias}
            {(idx < coll.length - 1) && ','}
            &nbsp;
          </Text>
        );
      })}
  </Text>
);

export default WorldParticipants;
